export default class FormCompose
{
    constructor()
    {
        // click on a form-check
        $('form').on('click', '.questions > .mb-4 > .form-check.radio', (e) => {
            this.clickFormCheckRadio(e);
        });
        $('form').on('click', '.questions > .mb-4 > .form-check.checkbox', (e) => {
            this.clickFormCheckCheckbox(e);
        });
    }

    /**
     * clickFormCheckRadio
     *
     * Clicking on a radio form-check div, will actually check the input
     *
     * @param {Object} event
     * @return null
     */
    clickFormCheckRadio(event)
    {
        let $formCheck = $(event.currentTarget);
        let $question  = $formCheck.closest('.mb-4');
        let $radio     = $formCheck.find('input');
        let $label     = $formCheck.find('label');

        $question.find('.form-check').removeClass('checked');

        if ($radio.is(':checked')) {
            $formCheck.addClass('checked');
        }
    }

    /**
     * clickFormCheckCheckbox
     *
     * Clicking on a checkbox form-check div, will actually check the input
     *
     * @param {Object} event
     * @return null
     */
    clickFormCheckCheckbox(event)
    {
        let $formCheck = $(event.currentTarget);
        let $question  = $formCheck.closest('.mb-4');
        let $checkbox  = $formCheck.find('input');
        let $label     = $formCheck.find('label');
        let name       = $checkbox.attr('name');

        if ($checkbox.is(':checked')) {
            $formCheck.addClass('checked');
        } else {
            $formCheck.removeClass('checked');
        }

        if ($checkbox.attr('required') || $checkbox.hasClass('checkbox-required')) {
            let checkedCount = $('input[name="' + name + '"]:checked');

            // if we have at least one box checked, then turn off required attribute
            if (checkedCount.length) {
                $('input[name="' + name + '"]').each(function(index, input) {
                    input.required = false;
                    input.classList.add('checkbox-required');
                });
            // if we don't have any boxes checked, make all required
            } else {
                $('input[name="' + name + '"]').each(function(index, input) {
                    input.required = true;
                });
            }
        }
    }
}

